// extracted by mini-css-extract-plugin
export default {"legendRoot":"styles_legendRoot__mL4BH","markerContainer":"styles_markerContainer__avrmW","barLegend":"styles_barLegend__rGB4x","splineLegend":"styles_splineLegend__lLIAu"};